<template>
  <div class="content" v-if="distribution._id">
    <div class="page-inner">
      <div class="page-header">
        <h4 class="page-title">{{ $t('reopening_reason') }}</h4>
        <ul class="breadcrumbs">
          <li class="nav-home">
            <router-link to="/dashboard">
              <i class="flaticon-home"></i>
            </router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <router-link to="/distributions">{{ $t('section_distribution') }}</router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a href="javascript:void(0)">{{ distribution.title }}</a>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-space">
            <div class="card-header clearfix">
              <div class="pull-left">
                <h4 class="card-title">{{ distribution.title }}</h4>
                <h4 class="card-subtitle">{{ distribution.artist.name }}</h4>
              </div>
              <button @click="removeRelease()" class="btn btn-sm pull-right" v-if="distribution && distribution._id && !distribution.status">
                <span class="fa fa-trash mr-1"></span> {{ $t('remove') }}
              </button>
            </div>
            <div class="card-body">
              <!-- already published -->
              <div class="row">
                <div class="col-12 col-md-12">
                  <div class="text-center mb-2 mt-2" v-if="!user.subscription">
                    <ins class="adsbygoogle"
                            style="display:block"
                            data-ad-client="ca-pub-8326584585992829"
                            data-ad-slot="8454890613"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                  </div>
                  <div class="tab-content" id="v-pills-tabContent">
                    <div class="tab-pane fade active show" id="v-pills-fix-icons" role="tabpanel" aria-labelledby="v-pills-fix-tab-icons">
                      <div class="accordion">
                        <div class="card mb-3">
                          <div class="card-header">
                            <span class="h1 text-dark fw-extrabold">{{ $t('release_rejected') }}</span>
                          </div>
                          <div class="card-body">
                            <div v-html="distribution.rejected_reason"></div>
                            <br>
                            <div v-if="reopenOption.require_evidence">
                              <div class="h1 text-dark fw-light">{{ $t('url_evidence') }}</div>
                              <ul class="list-group list-group-bordered list" v-for="(item, index) in filesToVerification" v-bind:key="index">
                                <li class="list-group-item">
                                  <div class="form-control">
                                    <div class="mt-2">
                                      {{item}}
                                      <button class="btn btn-primary btn-border text-18 ml-2 pr-2 pl-2 pt-1 pb-1" @click="removeURl(index)">
                                        <i class="fas fa-times-circle"></i>
                                      </button>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                              <div class="form-group pl-0">
                                <input id="urlToVerification" type="url" v-model="urlToVerification" placeholder="https://example.com" class="form-control d-inline" style="width:30%;" pattern="[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?" required>
                                <button class="btn btn-lg btn-primary btn-border" @click="addURL()">
                                  {{ $t('add_url') }} <i class="fas fa-plus-circle"></i>
                                </button>
                                <button class="btn btn-lg btn-primary" :disabled="enableChanges || loading" @click="saveUrlFile()">
                                  {{ $t('save_changes') }}
                                  <span v-if="loading">
                                    <i class="fa fa-spinner fa-spin"></i>
                                  </span>
                                </button>
                              </div>
                            </div>
                            <button class="btn btn-lg btn-primary" v-if="reopenOption.page_to_edit && distribution._id" @click="goToPage(reopenOption.page_to_edit.replace(':id', distribution._id))">
                              {{ $t('edit_distribution') }} <i class="fas fa-edit"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Distributions from '../services/distributions'
import Configuration from '../services/configuration'

export default {
  name: 'DistributionReopeningDetails',
  data: function () {
    return {
      distribution: {},
      moment: moment,
      reopeningOptions: [],
      reopenOption: {
        key: null,
        page_to_edit: null,
        require_evidence: null
      },
      filesToVerification: [],
      urlToVerification: '',
      enableChanges: true,
      loading: false
    }
  },
  computed: {},
  methods: {
    removeRelease: function () {
      window.swal({
        title: this.$t('warning'),
        text: this.$t('warning_delete_release'),
        className: 'icon-modal',
        icon: 'warning',
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: this.$t('cancel'),
            visible: true,
            className: 'btn btn-default'
          },
          confirm: {
            text: this.$t('confirm'),
            className: 'btn btn-success'
          }
        }
      }).then(confirm => {
        if (confirm) {
          Distributions.remove(this.distribution._id).then(response => {
            this.$notify({ message: this.$t('distribution_removed') }, 'success', 'fa-check')
            this.$router.push(`/distributions`)
          })
        }
      })
    },
    goToPage: function (url) {
      if (this.reopenOption.key) {
        Distributions.setReopenInProgress(this.distribution._id).then(response => {
          this.$router.push({path: url})
        })
      }
    },
    addURL: function () {
      if (!document.getElementById('urlToVerification').checkValidity()) {
        document.getElementById('urlToVerification').reportValidity()
      } else if (!_.contains(this.filesToVerification, this.urlToVerification)) {
        this.enableChanges = false
        this.filesToVerification.push(this.urlToVerification)
        this.urlToVerification = ''
      } else {
        this.urlToVerification = ''
        this.$notify({ message: this.$t('url_duplicated') }, 'warning', 'fa-times')
      }
    },
    removeURl: function (index) {
      this.enableChanges = false
      this.filesToVerification.splice(index, 1)
    },
    saveUrlFile: function () {
      if (this.filesToVerification) {
        Distributions.saveUrlFiles(this.distribution._id, this.filesToVerification).then(response => {
          this.$notify({ message: this.$t('updated_correctly') }, 'success', 'fa-check')
        })
      }
    }
  },
  created: function () {
    this.user = this.$user
    Configuration.get({fields: ['reopen_reasons_fields']}).then(response => {
      this.reopeningOptions = response.data.reopen_reasons_fields

      if (this.$route.params.id) {
        Distributions.get(this.$route.params.id).then(response => {
          this.distribution = response.data
          this.filesToVerification = this.distribution.reopen_evidence ? this.distribution.reopen_evidence : []

          if (this.distribution.status === 0 && !this.distribution.reopening_reason) {
            return this.$router.push(`/distributions/${this.$route.params.id}`)
          } else if (this.distribution.status > 0) {
            if (this.$route.params.id) {
              return this.$router.push(`/distributions/${this.$route.params.id}/details`)
            } else {
              return this.$router.push(`/distributions`)
            }
          }

          let reopOptions = _.filter(this.reopeningOptions, (elem, key) => {
            elem.key = key
            return key === this.distribution.reopening_reason
          })

          if (reopOptions.length) {
            this.reopenOption = reopOptions[0]
          }

          this.$forceUpdate()
        })
      }
    })
  },
  mounted: function () {
    if (!this.user.subscription) {
      setTimeout(() => {
        (window.adsbygoogle = window.adsbygoogle || []).push({})
      }, 2000)
    }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
#distribution-image {
  width: 200px;
  height: 200px;
  border-radius: 3px;
}

.low-quality-icon {
  font-size: 100px;
}

.vertical-line {
  width: 170px;
    height: 80px;
    border-bottom: 5px solid #F25861;
    transform: translateX(-44px) translateY(-110px) rotate(-45deg);
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributionReopeningDetails.vue